import { getSha256 } from 'utils/cryptoUtils'

// A Braze external_id in this app is sha256(lowercased email) → 64 lowercase hex chars.
// Validates the untrusted initial_braze_id URL param before it reaches Braze / the backend.
export const isBrazeExternalId = (value: string | null): value is string =>
  /^[a-f0-9]{64}$/.test(value ?? '')

export const toBrazeExternalId = (email: string): string =>
  getSha256(email.trim().toLowerCase())
